function executeSequentially(items, options) {
    const shouldSkip = options.shouldSkip || (() => false);
    const onStart = options.onStart || (() => {});
    const onSuccess = options.onSuccess || (() => {});
    const onFailure = options.onFailure || (() => {});

    return items.reduce((chain, item) => chain.then(() => {
        if (shouldSkip(item)) {
            return undefined;
        }

        onStart(item);
        return Promise.resolve()
            .then(() => options.execute(item))
            .then(result => onSuccess(item, result))
            .catch(error => onFailure(item, error));
    }), Promise.resolve());
}

module.exports = executeSequentially;
